import { useContext } from "react";
import SelectController from "../../../../../../core/ui/components/SelectController";
import useUser from "../../../../../../core/hooks/use-user";
import CuadroTurnosContext from "../../../../store/cuadro-turnos-context";
import SelectsFiltrosCuadrosTurnosContext from "../../../../store/selects-filtros-cuadros-turnos-context";

export default function SelectSedesAreasLider() {
    const { getUserData } = useUser();
    const user = getUserData();

    const { setFiltros } = useContext(CuadroTurnosContext);
    const { actualizarArea, areaId, setSubAreas } = useContext(
        SelectsFiltrosCuadrosTurnosContext
    );

    if (user.sedes_areas.length < 2) return <></>;

    const onChangeSedeAreaLider = (area) => {
        actualizarArea(area.value);
        setSubAreas([])
        setFiltros((prev) => {
            return { ...prev, sedeAreaLider: area.value, subAreasLider: null };
        });
    };

    const areas = user.sedes_areas.reduce((prev, sedeArea) => {
        if (!Object.prototype.hasOwnProperty.call(prev, sedeArea.area.id)) {
            prev[sedeArea.area.id] = {
                label: sedeArea.area.nombre,
                value: sedeArea.area.id,
            };
        }

        return prev;
    }, {});

    const options = Object.values(areas);
    const defaultValue = options.find((area) => area.value == areaId);

    return (
        <div>
            <label className="mt-2">
                <i className="fas fa-sort-amount-up"></i> Areas del Líder
            </label>
            <SelectController
                defaultValue={defaultValue}
                name="sedeAreaLider"
                onChange={onChangeSedeAreaLider}
                options={options}
                zIndex={999}
            />
        </div>
    );
}
